import React, { Component } from "react";

import { CButton } from "@coreui/react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { InputGroup, Input, FormGroup } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";

import "./css/resource.css";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/**
 * Moves an item from one list to another list.
 */

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 8;

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  flexFlow: "wrap",
  border: "1px solid #d8dbe0",
  borderRadius: "0.25rem"
});
const getListStyleOrderOnly = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  flexDirection: "column"
});
const dropeListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  border: "2px dashed #d8dbe0",
  borderRadius: "0.25rem",
  minHeight: "160px",
  overflowX: "scroll"
});

class DragAndDropActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selected: []
    };
  }

  id2List = {
    droppable: "items",
    droppable2: "selected"
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    let items = this.props.list;

    items.forEach((elem, idx) => {
      items[idx].content = elem.name;
    });

    this.setState({
      items
    });
  }

  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    let draggedItem = result.draggableId;

    let target = result.destination.droppableId;

    if (
      source.droppableId === destination.droppableId &&
      source.droppableId === "droppable2"
    ) {
      // just order
      let list2 = [];
      this.props.list2.forEach(item => {
        list2.push(item);
      });

      list2 = reorder(list2, source.index, destination.index);

      this.props.getOrder(list2);
    } else if (source.droppableId !== destination.droppableId) {
      // select
      let list = this.getList(source.droppableId);
      list.forEach(item => {
        if (item.id === draggedItem) {
          draggedItem = item;
        }
      });
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      if (this.props.dontChangeListOnSelect) {
        this.setState(
          {
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.props.selectedItem(draggedItem);
            }
            this.props.getSelected(this.state.selected);
          }
        );
      } else {
        this.setState(
          {
            items: result.droppable,
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.props.selectedItem(draggedItem);
            }
            this.props.getSelected(this.state.selected);
          }
        );
      }
    }
  };

  selectChange = item => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let items = this.state.items;
    items.forEach((selected, idx) => {
      if (item.id === selected.id) {
        if (selected.checked) {
          items[idx].checked = false;
        } else {
          items[idx].checked = true;
        }
      }
    });

    this.setState({
      items
    });

    this.props.getChecked(item);
  };

  render() {
    let time = new Date().getTime();

    return (
      <div>
        <DragDropContext
          onDragEnd={this.onDragEnd}
          className="warpTypeResources"
        >
          <Droppable droppableId="droppable" direction={this.props.direction}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={
                  this.props.orderOnly
                    ? getListStyleOrderOnly(snapshot.isDraggingOver)
                    : getListStyle(snapshot.isDraggingOver)
                }
              >
                {this.state.items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        key={item.id}
                        className={
                          this.props.orderOnly ? "orderContent" : "typeBox"
                        }
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="warp-item-dnd">
                          {this.props.checkbox ? (
                            <div>
                              <FormGroup className="filterCheckBox dndCheckBox">
                                <InputGroup>
                                  <Input
                                    placeholder="select"
                                    onChange={e => this.selectChange(item)}
                                    checked={item.checked}
                                    type="checkbox"
                                  />
                                </InputGroup>
                              </FormGroup>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="w-100 h-100">
                            <div className="typeContent">
                              {!this.props.orderOnly ? (
                                item.icon ? (
                                  <div className={`typeIcon bg-${item.color}`}>
                                    <i className={`fa fa-${item.icon}`}></i>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                              <div className="typeTitle text-ellipsis">
                                {item.content}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          {this.props.dropArea ? (
            <div>
              <div className="mt-3 mb-2">{this.props.dropName}</div>
              <Droppable
                isDropDisabled={this.props.dropDisable}
                droppableId="droppable2"
                direction={this.props.direction}
              >
                {(provided, snapshot) => (
                  <div
                    key={`${time}droppable2`}
                    ref={provided.innerRef}
                    style={dropeListStyle(snapshot.isDraggingOver)}
                  >
                    {this.props.list2.map((item, index) => (
                      <div style={{ backgroundColor: "white" }}>
                        <Draggable
                          key={index}
                          draggableId={`${item.type}-${item.list.id}-selected-${time}`}
                          // isDragDisabled
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              key={`${item.type}-${item.list.id}-${time}`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="typeBox editable"
                            >
                              <div
                                className="typeEdit"
                                onClick={() =>
                                  this.props.editItem(
                                    item.type,
                                    item.list.id,
                                    this.state.items.find(
                                      type => type.id === item.type
                                    )
                                  )
                                }
                              >
                                <div
                                  className={`bg-helper bg-${
                                    item.type === 23
                                      ? "dark"
                                      : this.state.items.find(
                                          type => type.id === item.type
                                        )?.color || "warning"
                                  }`}
                                ></div>
                                <i className="fa fa-pencil text-white" />
                              </div>
                              <CButton
                                color="secondary"
                                className="typeCloseButton"
                                onClick={() =>
                                  this.props.removeItem(item.type, item.list.id)
                                }
                              >
                                <i className="fa fa-close"></i>
                              </CButton>
                              <div className="typeContent">
                                <div
                                  className={`typeIcon bg-${
                                    item.type === 23
                                      ? "dark"
                                      : this.state.items.find(
                                          type => type.id === item.type
                                        )?.color
                                  }`}
                                >
                                  <i
                                    className={`h-auto fa fa-${
                                      item.type === 23
                                        ? "video-camera"
                                        : this.state.items.find(
                                            type => type.id === item.type
                                          )?.icon
                                    }`}
                                  ></i>
                                </div>
                                <div className="typeTitle text-ellipsis">
                                  {item.list.name}
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      </div>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          ) : (
            ""
          )}
        </DragDropContext>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DragAndDropActivity);
